module.exports = __webpack_public_path__ + "img/registerlogin_6.0744a705.jpg";